import React, {useEffect} from 'react'
import { YearEnd } from '../../components';
import {getYearEnd} from "../../reducers/YearEndReducer";
import {useDispatch, useSelector} from "react-redux";

function YearEndContainer(props) {
    
    const datakey = props.datakey;
    
    const dispatch = useDispatch();
    const {data,loading,error} = useSelector(state=> state.yearend);
    
    useEffect(() => {
        
        dispatch(getYearEnd({datakey}));
        
        return () => {
          console.log('컴포넌트가 화면에서 사라짐');
        };
      }, [dispatch]);

    if (loading && !data) return <div>로딩중...</div> // 로딩중이면서, 데이터가 없을떄에만 로딩중... 표시
    if (error) return <div>에러</div>
    if (!data) return <div>404</div>
    
    return (
        <YearEnd data = {data}></YearEnd>
    )
}

export default YearEndContainer
